// @ts-nocheck
import { useEffect, useState } from 'react';

import { getApiCall } from '@/service/httpCall';
import { API_COMPANY_ASSETS_VISIBILITY_ELIGIBILITY } from '@/service/url';

const EMPTY = {
  can_grant: false,
  is_super_admin: false,
  runs_call_centre: false,
  assigned_company: null,
  allowed_asset_types: [],
};

let cached = null;
let inFlight = null;

export function resetAssetsVisibilityEligibility() {
  cached = null;
  inFlight = null;
}

async function load() {
  if (cached) return cached;

  if (!inFlight) {
    inFlight = getApiCall(API_COMPANY_ASSETS_VISIBILITY_ELIGIBILITY)
      .then((resp) => {
        cached = resp || EMPTY;
        return cached;
      })
      .catch(() => {
        cached = EMPTY;
        return cached;
      })
      .finally(() => {
        inFlight = null;
      });
  }

  return inFlight;
}

export function useAssetsVisibilityEligibility() {
  const [eligibility, setEligibility] = useState(cached || EMPTY);
  const [loading, setLoading] = useState(!cached);

  useEffect(() => {
    let alive = true;

    if (cached) {
      setEligibility(cached);
      setLoading(false);
      return () => {
        alive = false;
      };
    }

    load().then((value) => {
      if (!alive) return;
      setEligibility(value);
      setLoading(false);
    });

    return () => {
      alive = false;
    };
  }, []);

  const allowedAssetTypes = Array.isArray(eligibility.allowed_asset_types)
    ? eligibility.allowed_asset_types
    : [];

  return {
    eligibility,
    loading,
    allowedAssetTypes,
    canChangeOwnAssetsVisibility: allowedAssetTypes.length > 0,
    canGrantAssetsVisibility: eligibility.can_grant === true,
    assignedCompany: eligibility.assigned_company,
    hasCallCentreAdminChild: eligibility.runs_call_centre === true,
    isSuperAdmin: eligibility.is_super_admin === true,
  };
}
